// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"6037":"css/admin-app.7063","8840":"css/app.7063"}[chunkId] + ".css";
};